import type { ReactNode } from 'react'
import { useHandregalZaehlstand } from '@/api/warehouse'

const zeit = (value: string) => new Date(value).toLocaleTimeString('de-DE', {
  timeZone: 'Europe/Berlin', hour: '2-digit', minute: '2-digit',
})
const zaehlzeit = (value: string) => `${new Date(value).toLocaleDateString('de-DE', {
  timeZone: 'Europe/Berlin', day: '2-digit', month: '2-digit',
})} ${zeit(value)}`
const zahl = (value: number) => value < 0 ? `−${Math.abs(value).toLocaleString('de-DE')}` : value.toLocaleString('de-DE')

/** Mounted only for warehouse leads; other roles never call the protected read hook. */
export default function HandregalZaehlerFeld({ merchantSku }: { merchantSku: string }) {
  const query = useHandregalZaehlstand()
  let content: ReactNode
  if (query.isError) content = <div role="alert" className="text-[var(--bel-ink)]">Zählstand konnte nicht geladen werden. Bitte erneut laden.</div>
  else if (!query.data) content = <div role="status" className="text-[var(--muted)]">Lade Zählstand …</div>
  else {
    const { stand, zeilen } = query.data
    const row = zeilen.get(merchantSku)
    if (!row) content = <div className="text-[var(--muted)]">noch nicht gezählt</div>
    else if (!stand.aktuell || row.physisch === null || row.frei === null || row.offen === null) {
      content = <div className="text-[var(--muted)]">Zähler nicht aktuell ({stand.letzter_erfolg
        ? `Stand ${zeit(stand.letzter_erfolg)}` : 'noch kein Lauf'})</div>
    } else content = <>
      <div className="flex flex-wrap items-center gap-2" style={{ fontVariantNumeric: 'tabular-nums' }}>
        <span>physisch {zahl(row.physisch)}</span><span aria-hidden="true">·</span>
        <span className={row.frei < 0 ? 'text-[var(--bel-ink)]' : undefined}>frei {zahl(row.frei)}</span>
      </div>
      <div className="text-xs text-[var(--muted)]">gezählt {zahl(row.gezaehlt)} am {zaehlzeit(row.counted_at)} − {zahl(row.abgang)} raus + {zahl(row.zugang)} rein − {zahl(row.offen)} offen</div>
      {row.frei < 0 && <div role="status" className="mt-1 text-[var(--bel-ink)]">Überverkauf: {zahl(-row.frei)} Stück mehr verkauft als im Fach</div>}
    </>
  }
  return <div data-testid="handregal-zaehler-feld" className="mt-1 min-w-0 text-[13px] text-[var(--ink)] break-words">{content}</div>
}
